const SESSION_EXPIRED_EVENT = 'cdcb:auth-session-expired';

let sessionExpiredNotified = false;

export interface SessionExpiredDetail {
    reason?: string;
    status?: number;
    path?: string;
}

export function emitSessionExpired(detail?: SessionExpiredDetail) {
    if (typeof window === 'undefined') return;
    if (sessionExpiredNotified) return;

    sessionExpiredNotified = true;
    window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, { detail }));
}

export function resetSessionExpiredNotification() {
    sessionExpiredNotified = false;
}

export function getSessionExpiredEventName() {
    return SESSION_EXPIRED_EVENT;
}